import PosSettingsSection from "@/components/PosSettingsSection";

/**
 * Standalone POS Settings page, accessible to ALL authenticated users
 * (not just supervisor/manager). Renders the same section used inside the
 * ΑΣΦΑΛΕΙΑ page for admins.
 */
export default function Settings() {
    return (
        <div className="p-6 md:p-10 max-w-5xl">
            <div className="mb-6">
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#5C5F66]">
                    ΣΥΣΤΗΜΑ
                </div>
                <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tighter text-[#0A0A0A]">
                    ΡΥΘΜΙΣΕΙΣ
                </h1>
                <p className="text-sm text-[#5C5F66] mt-1">
                    Ρυθμίσεις λειτουργίας ταμείου. Οι αλλαγές ισχύουν άμεσα για όλους τους χρήστες.
                </p>
            </div>
            <PosSettingsSection />
        </div>
    );
}
